module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_combo_simple_y_duo_cuadrada_fondo_motivo_1.593c08fc.png";